import { render, staticRenderFns } from "./transcript-reason-action.vue?vue&type=template&id=8bb86a30&scoped=true&"
import script from "./transcript-reason-action.vue?vue&type=script&lang=js&"
export * from "./transcript-reason-action.vue?vue&type=script&lang=js&"
import style0 from "./transcript-reason-action.vue?vue&type=style&index=0&id=8bb86a30&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb86a30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bb86a30')) {
      api.createRecord('8bb86a30', component.options)
    } else {
      api.reload('8bb86a30', component.options)
    }
    module.hot.accept("./transcript-reason-action.vue?vue&type=template&id=8bb86a30&scoped=true&", function () {
      api.rerender('8bb86a30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/transcript-reason-action/transcript-reason-action.vue"
export default component.exports